import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { fallbackRefetchInterval } from '@/lib/realtime';
import { useSocketStore } from '@/stores/socketStore';
import type { Intervention } from '@/lib/types';

/**
 * RDV d'un mécano pour un jour donné — alimente l'agenda du formulaire RDV
 * (blocs occupés). Réutilise l'endpoint existant filtré côté backend.
 *
 * @param dateIso        jour YYYY-MM-DD
 * @param mecanicienId   mécano sélectionné (sinon requête désactivée)
 * @param enabled        vue Jour active + champs amont remplis
 */
export function useDayInterventions(
  dateIso: string,
  mecanicienId: string | undefined,
  enabled: boolean,
) {
  const connected = useSocketStore((s) => s.connected);
  return useQuery({
    queryKey: ['day-interventions', dateIso, mecanicienId],
    queryFn: () =>
      api.get<{ interventions: Intervention[] }>(
        `/interventions?date=${dateIso}&mecanicienId=${mecanicienId}`,
      ),
    // Sécurité : exclut les RDV annulés (le backend exclut déjà deletedAt).
    select: (data) => data.interventions.filter((i) => i.statut !== 'ANNULE'),
    enabled: enabled && !!mecanicienId,
    staleTime: 10_000,
    // Filet (socket tombé seulement) : l'agenda ne reste pas figé si un autre
    // poste pose un RDV. Connecté, l'invalidation socket suffit.
    refetchInterval: fallbackRefetchInterval(connected, 30_000),
  });
}
